import { GetDashboardUnits } from '~/domain/usecases/dashboard/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import { UnexpectedError, NotFound, Forbidden } from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteGetDashboardUnits implements GetDashboardUnits {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetDashboardUnits.Model>;

  constructor(url: string, httClient: HttpClient<GetDashboardUnits.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetDashboardUnits.Params,
  ): Promise<GetDashboardUnits.Model> => {
    let queryParams: any = {
      begin: undefined,
      end: undefined,
    };

    if (params.filter && params.filter.year && params.filter.month) {
      queryParams = {
        begin: new Date(
          params.filter.year,
          params.filter.month - 1,
          1,
        ).toISOString(),
        end: new Date(params.filter.year, params.filter.month).toISOString(),
      };
    }

    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.filter?.org}/units`,
      method: 'get',
      params: queryParams,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new UnexpectedError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
